import React from "react"
import styled from "@emotion/styled"

const Container = styled.div`
  width: 100%;
  margin-top: 3rem;
  margin-left: 3rem;
  flex-basis: 40%;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    margin: 0 0 1rem;
  }
  p {
    font: 400 ${props => props.theme.fontSize.paragraph}
      ${props => props.theme.fonts.sans};
    margin-bottom: 1rem;
  }
  ul {
    font: 400 ${props => props.theme.fontSize.small}
      ${props => props.theme.fonts.sans};
    padding: 1rem;
    margin: 0;
    background-color: #d5d9dd;
    list-style: none;
    li {
      border-bottom: 1px solid gray;
      padding: 0.5rem 0;
      a {
        text-decoration: none;
        color: ${props => props.theme.colors.primary};
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`

const ViewMore = ({ children }) => <Container>{children}</Container>

export default ViewMore
